module.exports = __webpack_public_path__ + "img/flfg.2671233a.png";